export const INJECTED_COLOR_MODE = 'INJECTED_COLOR_MODE';

/** Provide/Inject: ob die aktuelle Seite zur Account-Area gehört */
export const IS_ACCOUNT_AREA = 'IS_ACCOUNT_AREA';

/** Provide/Inject: Titel der aktuellen Contentful-Seite */
export const CONTENT_PAGE_TITLE = 'CONTENT_PAGE_TITLE';

/** Provide/Inject: TOC-Flags der aktuellen Contentful-Seite */
export const TOC_INFO = 'TOC_INFO';

/**
 * Provide/Inject: product list is rendered inside a Contentful tab module.
 * Full-width product lists stay opt-out there.
 */
export const PRODUCT_LIST_EMBEDDED_IN_TAB = 'PRODUCT_LIST_EMBEDDED_IN_TAB';

/** Contentful pageLayout-Wert für die Account-Area (Two-Column-Layout) */
export const PAGE_LAYOUT_ACCOUNT_AREA = 'Two-Column-Layout';

/** Prüft, ob die übergebene Seite/Content-Page zur Account-Area gehört. */
export function isAccountAreaPage(
  page: { fields?: { pageLayout?: string } } | null | undefined
): boolean {
  return page?.fields?.pageLayout === PAGE_LAYOUT_ACCOUNT_AREA;
}

export const QUERY_PARAM_LOGGEDIN = 'loggedIn';
export const QUERY_PARAM_LOGGOUT = 'loggedOut';
export const QUERY_PARAM_SIGNUP = 'signUp';

export const BASLER_EXPRESS_DELIVERY_CARRIER_CODE = 'basler_tablerate';
export const BASLER_STANDARD_DELIVERY_CARRIER_CODE = 'tablerate';
export const BASLER_PICKUP_CARRIER_CODE = 'pickupdelivery';

export const G4_EVENT_NAME_ADD_TO_CART = 'add_to_cart';
export const G4_EVENT_NAME_ADD_TO_REQUESTCART = 'request_quote';
export const G4_EVENT_NAME_VIEW_CART = 'view_cart';
/** Custom event for Request Cart / Quote: product list is tracked (GA4 does not recommend view_request_cart). Funnel: request_quote → view_quote → start_quote → send_quote */
export const G4_EVENT_NAME_VIEW_QUOTE = 'view_quote';
export const G4_EVENT_NAME_START_QUOTE = 'start_quote';
export const G4_EVENT_NAME_REMOVE_FROM_CART = 'remove_from_cart';
export const G4_EVENT_NAME_UPDATE_CART = 'update_cart';
export const G4_EVENT_NAME_BEGIN_CHECKOUT = 'begin_checkout';
export const G4_EVENT_NAME_ADD_SHIPPING_INFO = 'add_shipping_info';
export const G4_EVENT_NAME_ADD_PAYMENT_INFO = 'add_payment_info';
export const G4_EVENT_NAME_ORDER_AS_GUEST = 'checkout_guest_click';
export const G4_EVENT_NAME_PURCHASE = 'purchase';
export const G4_EVENT_NAME_SEND_QUOTE = 'send_quote';
/** NBQ (Non-Binding Quote / Angebots-PDF) funnel: show_nbq → start_nbq → create_nbq → send_nbq */
export const G4_EVENT_NAME_SHOW_NBQ = 'show_nbq';
export const G4_EVENT_NAME_START_NBQ = 'start_nbq';
export const G4_EVENT_NAME_CREATE_NBQ = 'create_nbq';
export const G4_EVENT_NAME_SEND_NBQ = 'send_nbq';
export const G4_EVENT_NAME_LOGIN = 'login';
export const G4_EVENT_NAME_LOGOUT = 'logout';
export const G4_EVENT_NAME_SIGN_UP = 'sign_up';
export const G4_METHOD_NAME_BASLER_ID = 'Basler ID';

/** Nur für LensFinder: Produktfamilien/ -linien, die ausgeschlossen werden */
export const FORBIDDEN_LENS_PRODUCT_FINDER_PRODUCT_FAMILIES: string[] = [
  'dart M'
];
export const FORBIDDEN_LENS_PRODUCT_FINDER_PRODUCT_LINES: string[] = [
  'ace 2 R with IP67',
  'ace 2 X UV'
];
